import { render, staticRenderFns } from "./ComfortCreditInfo.vue?vue&type=template&id=5b99a416"
import script from "./ComfortCreditInfo.vue?vue&type=script&lang=js"
export * from "./ComfortCreditInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports